/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index';
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$';
import { Route as AuthenticatedAcknowledgementsRouteImport } from './routes/_authenticated/acknowledgements';
import { Route as AuthenticatedAssistantRouteImport } from './routes/_authenticated/assistant';
import { Route as AuthenticatedContractsRouteImport } from './routes/_authenticated/contracts';
import { Route as AuthenticatedCorrespondenceRouteImport } from './routes/_authenticated/correspondence';
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard';
import { Route as AuthenticatedEvaluationRouteImport } from './routes/_authenticated/evaluation';
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile';
import { Route as AuthenticatedReferenceRouteImport } from './routes/_authenticated/reference';
import { Route as InviteTokenRouteImport } from './routes/invite.$token';
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token';
import { Route as AuthenticatedActsIndexRouteImport } from './routes/_authenticated/acts/index';
import { Route as AuthenticatedActsActIdRouteImport } from './routes/_authenticated/acts/$actId';
import { Route as AuthenticatedAdminAiProvidersRouteImport } from './routes/_authenticated/admin/ai-providers';
import { Route as AuthenticatedAdminExternalCallsRouteImport } from './routes/_authenticated/admin/external-calls';
import { Route as AuthenticatedAdminRolesRouteImport } from './routes/_authenticated/admin/roles';
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index';
import { Route as AuthenticatedDocumentsDocumentIdRouteImport } from './routes/_authenticated/documents/$documentId';
import { Route as AuthenticatedDraftsIndexRouteImport } from './routes/_authenticated/drafts/index';
import { Route as AuthenticatedDraftsDraftIdRouteImport } from './routes/_authenticated/drafts/$draftId';
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security';
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates/index';
import { Route as AuthenticatedTemplatesTemplateIdRouteImport } from './routes/_authenticated/templates/$templateId';
import { Route as AuthenticatedAdminMembersIndexRouteImport } from './routes/_authenticated/admin/members/index';
import { Route as AuthenticatedAdminMembersUserIdRouteImport } from './routes/_authenticated/admin/members/$userId';
import { Route as AuthenticatedAdminMembersInvitationsRouteImport } from './routes/_authenticated/admin/members/invitations';
import { Route as AuthenticatedAdminMembersInviteRouteImport } from './routes/_authenticated/admin/members/invite';
import { Route as AuthenticatedAdminTeamsIndexRouteImport } from './routes/_authenticated/admin/teams/index';
import { Route as AuthenticatedAdminTeamsTeamIdRouteImport } from './routes/_authenticated/admin/teams/$teamId';
import { Route as AuthenticatedTemplatesTemplateIdFillRouteImport } from './routes/_authenticated/templates/$templateId_/fill';
import { Route as AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRouteImport } from './routes/_authenticated/templates/$templateId_/assemblies/$assemblyId';
import { Route as AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRouteImport } from './routes/_authenticated/templates/$templateId_/versions/$versionId/edit';

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedAcknowledgementsRoute =
  AuthenticatedAcknowledgementsRouteImport.update({
    id: '/acknowledgements',
    path: '/acknowledgements',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssistantRoute = AuthenticatedAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedContractsRoute = AuthenticatedContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedCorrespondenceRoute =
  AuthenticatedCorrespondenceRouteImport.update({
    id: '/correspondence',
    path: '/correspondence',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEvaluationRoute = AuthenticatedEvaluationRouteImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedReferenceRoute = AuthenticatedReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedActsIndexRoute = AuthenticatedActsIndexRouteImport.update({
  id: '/acts/',
  path: '/acts/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedActsActIdRoute = AuthenticatedActsActIdRouteImport.update({
  id: '/acts/$actId',
  path: '/acts/$actId',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedAdminAiProvidersRoute =
  AuthenticatedAdminAiProvidersRouteImport.update({
    id: '/admin/ai-providers',
    path: '/admin/ai-providers',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminExternalCallsRoute =
  AuthenticatedAdminExternalCallsRouteImport.update({
    id: '/admin/external-calls',
    path: '/admin/external-calls',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminRolesRoute = AuthenticatedAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDocumentsDocumentIdRoute =
  AuthenticatedDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDraftsIndexRoute =
  AuthenticatedDraftsIndexRouteImport.update({
    id: '/drafts/',
    path: '/drafts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDraftsDraftIdRoute =
  AuthenticatedDraftsDraftIdRouteImport.update({
    id: '/drafts/$draftId',
    path: '/drafts/$draftId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTemplatesTemplateIdRoute =
  AuthenticatedTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminMembersIndexRoute =
  AuthenticatedAdminMembersIndexRouteImport.update({
    id: '/admin/members/',
    path: '/admin/members/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminMembersUserIdRoute =
  AuthenticatedAdminMembersUserIdRouteImport.update({
    id: '/admin/members/$userId',
    path: '/admin/members/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminMembersInvitationsRoute =
  AuthenticatedAdminMembersInvitationsRouteImport.update({
    id: '/admin/members/invitations',
    path: '/admin/members/invitations',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminMembersInviteRoute =
  AuthenticatedAdminMembersInviteRouteImport.update({
    id: '/admin/members/invite',
    path: '/admin/members/invite',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminTeamsIndexRoute =
  AuthenticatedAdminTeamsIndexRouteImport.update({
    id: '/admin/teams/',
    path: '/admin/teams/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAdminTeamsTeamIdRoute =
  AuthenticatedAdminTeamsTeamIdRouteImport.update({
    id: '/admin/teams/$teamId',
    path: '/admin/teams/$teamId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTemplatesTemplateIdFillRoute =
  AuthenticatedTemplatesTemplateIdFillRouteImport.update({
    id: '/templates/$templateId_/fill',
    path: '/templates/$templateId/fill',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute =
  AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRouteImport.update({
    id: '/templates/$templateId_/assemblies/$assemblyId',
    path: '/templates/$templateId/assemblies/$assemblyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute =
  AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRouteImport.update({
    id: '/templates/$templateId_/versions/$versionId/edit',
    path: '/templates/$templateId/versions/$versionId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/acknowledgements': typeof AuthenticatedAcknowledgementsRoute;
  '/assistant': typeof AuthenticatedAssistantRoute;
  '/contracts': typeof AuthenticatedContractsRoute;
  '/correspondence': typeof AuthenticatedCorrespondenceRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/evaluation': typeof AuthenticatedEvaluationRoute;
  '/profile': typeof AuthenticatedProfileRoute;
  '/reference': typeof AuthenticatedReferenceRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/reset-password/$token': typeof ResetPasswordTokenRoute;
  '/acts/$actId': typeof AuthenticatedActsActIdRoute;
  '/admin/ai-providers': typeof AuthenticatedAdminAiProvidersRoute;
  '/admin/external-calls': typeof AuthenticatedAdminExternalCallsRoute;
  '/admin/roles': typeof AuthenticatedAdminRolesRoute;
  '/documents/$documentId': typeof AuthenticatedDocumentsDocumentIdRoute;
  '/drafts/$draftId': typeof AuthenticatedDraftsDraftIdRoute;
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute;
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute;
  '/acts/': typeof AuthenticatedActsIndexRoute;
  '/documents/': typeof AuthenticatedDocumentsIndexRoute;
  '/drafts/': typeof AuthenticatedDraftsIndexRoute;
  '/templates/': typeof AuthenticatedTemplatesIndexRoute;
  '/admin/members/$userId': typeof AuthenticatedAdminMembersUserIdRoute;
  '/admin/members/invitations': typeof AuthenticatedAdminMembersInvitationsRoute;
  '/admin/members/invite': typeof AuthenticatedAdminMembersInviteRoute;
  '/admin/teams/$teamId': typeof AuthenticatedAdminTeamsTeamIdRoute;
  '/templates/$templateId/fill': typeof AuthenticatedTemplatesTemplateIdFillRoute;
  '/admin/members/': typeof AuthenticatedAdminMembersIndexRoute;
  '/admin/teams/': typeof AuthenticatedAdminTeamsIndexRoute;
  '/templates/$templateId/assemblies/$assemblyId': typeof AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute;
  '/templates/$templateId/versions/$versionId/edit': typeof AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute;
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/acknowledgements': typeof AuthenticatedAcknowledgementsRoute;
  '/assistant': typeof AuthenticatedAssistantRoute;
  '/contracts': typeof AuthenticatedContractsRoute;
  '/correspondence': typeof AuthenticatedCorrespondenceRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/evaluation': typeof AuthenticatedEvaluationRoute;
  '/profile': typeof AuthenticatedProfileRoute;
  '/reference': typeof AuthenticatedReferenceRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/reset-password/$token': typeof ResetPasswordTokenRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/acts/$actId': typeof AuthenticatedActsActIdRoute;
  '/admin/ai-providers': typeof AuthenticatedAdminAiProvidersRoute;
  '/admin/external-calls': typeof AuthenticatedAdminExternalCallsRoute;
  '/admin/roles': typeof AuthenticatedAdminRolesRoute;
  '/documents/$documentId': typeof AuthenticatedDocumentsDocumentIdRoute;
  '/drafts/$draftId': typeof AuthenticatedDraftsDraftIdRoute;
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute;
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute;
  '/acts': typeof AuthenticatedActsIndexRoute;
  '/documents': typeof AuthenticatedDocumentsIndexRoute;
  '/drafts': typeof AuthenticatedDraftsIndexRoute;
  '/templates': typeof AuthenticatedTemplatesIndexRoute;
  '/admin/members/$userId': typeof AuthenticatedAdminMembersUserIdRoute;
  '/admin/members/invitations': typeof AuthenticatedAdminMembersInvitationsRoute;
  '/admin/members/invite': typeof AuthenticatedAdminMembersInviteRoute;
  '/admin/teams/$teamId': typeof AuthenticatedAdminTeamsTeamIdRoute;
  '/templates/$templateId/fill': typeof AuthenticatedTemplatesTemplateIdFillRoute;
  '/admin/members': typeof AuthenticatedAdminMembersIndexRoute;
  '/admin/teams': typeof AuthenticatedAdminTeamsIndexRoute;
  '/templates/$templateId/assemblies/$assemblyId': typeof AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute;
  '/templates/$templateId/versions/$versionId/edit': typeof AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/_authenticated/$': typeof AuthenticatedSplatRoute;
  '/_authenticated/acknowledgements': typeof AuthenticatedAcknowledgementsRoute;
  '/_authenticated/assistant': typeof AuthenticatedAssistantRoute;
  '/_authenticated/contracts': typeof AuthenticatedContractsRoute;
  '/_authenticated/correspondence': typeof AuthenticatedCorrespondenceRoute;
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute;
  '/_authenticated/evaluation': typeof AuthenticatedEvaluationRoute;
  '/_authenticated/profile': typeof AuthenticatedProfileRoute;
  '/_authenticated/reference': typeof AuthenticatedReferenceRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/reset-password/$token': typeof ResetPasswordTokenRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/_authenticated/acts/$actId': typeof AuthenticatedActsActIdRoute;
  '/_authenticated/admin/ai-providers': typeof AuthenticatedAdminAiProvidersRoute;
  '/_authenticated/admin/external-calls': typeof AuthenticatedAdminExternalCallsRoute;
  '/_authenticated/admin/roles': typeof AuthenticatedAdminRolesRoute;
  '/_authenticated/documents/$documentId': typeof AuthenticatedDocumentsDocumentIdRoute;
  '/_authenticated/drafts/$draftId': typeof AuthenticatedDraftsDraftIdRoute;
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute;
  '/_authenticated/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute;
  '/_authenticated/acts/': typeof AuthenticatedActsIndexRoute;
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute;
  '/_authenticated/drafts/': typeof AuthenticatedDraftsIndexRoute;
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute;
  '/_authenticated/admin/members/$userId': typeof AuthenticatedAdminMembersUserIdRoute;
  '/_authenticated/admin/members/invitations': typeof AuthenticatedAdminMembersInvitationsRoute;
  '/_authenticated/admin/members/invite': typeof AuthenticatedAdminMembersInviteRoute;
  '/_authenticated/admin/teams/$teamId': typeof AuthenticatedAdminTeamsTeamIdRoute;
  '/_authenticated/templates/$templateId_/fill': typeof AuthenticatedTemplatesTemplateIdFillRoute;
  '/_authenticated/admin/members/': typeof AuthenticatedAdminMembersIndexRoute;
  '/_authenticated/admin/teams/': typeof AuthenticatedAdminTeamsIndexRoute;
  '/_authenticated/templates/$templateId_/assemblies/$assemblyId': typeof AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute;
  '/_authenticated/templates/$templateId_/versions/$versionId/edit': typeof AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/$'
    | '/acknowledgements'
    | '/assistant'
    | '/contracts'
    | '/correspondence'
    | '/dashboard'
    | '/evaluation'
    | '/profile'
    | '/reference'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/acts/$actId'
    | '/admin/ai-providers'
    | '/admin/external-calls'
    | '/admin/roles'
    | '/documents/$documentId'
    | '/drafts/$draftId'
    | '/settings/security'
    | '/templates/$templateId'
    | '/acts/'
    | '/documents/'
    | '/drafts/'
    | '/templates/'
    | '/admin/members/$userId'
    | '/admin/members/invitations'
    | '/admin/members/invite'
    | '/admin/teams/$teamId'
    | '/templates/$templateId/fill'
    | '/admin/members/'
    | '/admin/teams/'
    | '/templates/$templateId/assemblies/$assemblyId'
    | '/templates/$templateId/versions/$versionId/edit';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/forgot-password'
    | '/login'
    | '/$'
    | '/acknowledgements'
    | '/assistant'
    | '/contracts'
    | '/correspondence'
    | '/dashboard'
    | '/evaluation'
    | '/profile'
    | '/reference'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/'
    | '/acts/$actId'
    | '/admin/ai-providers'
    | '/admin/external-calls'
    | '/admin/roles'
    | '/documents/$documentId'
    | '/drafts/$draftId'
    | '/settings/security'
    | '/templates/$templateId'
    | '/acts'
    | '/documents'
    | '/drafts'
    | '/templates'
    | '/admin/members/$userId'
    | '/admin/members/invitations'
    | '/admin/members/invite'
    | '/admin/teams/$teamId'
    | '/templates/$templateId/fill'
    | '/admin/members'
    | '/admin/teams'
    | '/templates/$templateId/assemblies/$assemblyId'
    | '/templates/$templateId/versions/$versionId/edit';
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/_authenticated/$'
    | '/_authenticated/acknowledgements'
    | '/_authenticated/assistant'
    | '/_authenticated/contracts'
    | '/_authenticated/correspondence'
    | '/_authenticated/dashboard'
    | '/_authenticated/evaluation'
    | '/_authenticated/profile'
    | '/_authenticated/reference'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/_authenticated/'
    | '/_authenticated/acts/$actId'
    | '/_authenticated/admin/ai-providers'
    | '/_authenticated/admin/external-calls'
    | '/_authenticated/admin/roles'
    | '/_authenticated/documents/$documentId'
    | '/_authenticated/drafts/$draftId'
    | '/_authenticated/settings/security'
    | '/_authenticated/templates/$templateId'
    | '/_authenticated/acts/'
    | '/_authenticated/documents/'
    | '/_authenticated/drafts/'
    | '/_authenticated/templates/'
    | '/_authenticated/admin/members/$userId'
    | '/_authenticated/admin/members/invitations'
    | '/_authenticated/admin/members/invite'
    | '/_authenticated/admin/teams/$teamId'
    | '/_authenticated/templates/$templateId_/fill'
    | '/_authenticated/admin/members/'
    | '/_authenticated/admin/teams/'
    | '/_authenticated/templates/$templateId_/assemblies/$assemblyId'
    | '/_authenticated/templates/$templateId_/versions/$versionId/edit';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LoginRoute: typeof LoginRoute;
  InviteTokenRoute: typeof InviteTokenRoute;
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$': {
      id: '/_authenticated/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof AuthenticatedSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/acknowledgements': {
      id: '/_authenticated/acknowledgements';
      path: '/acknowledgements';
      fullPath: '/acknowledgements';
      preLoaderRoute: typeof AuthenticatedAcknowledgementsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/assistant': {
      id: '/_authenticated/assistant';
      path: '/assistant';
      fullPath: '/assistant';
      preLoaderRoute: typeof AuthenticatedAssistantRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/contracts': {
      id: '/_authenticated/contracts';
      path: '/contracts';
      fullPath: '/contracts';
      preLoaderRoute: typeof AuthenticatedContractsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/correspondence': {
      id: '/_authenticated/correspondence';
      path: '/correspondence';
      fullPath: '/correspondence';
      preLoaderRoute: typeof AuthenticatedCorrespondenceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/evaluation': {
      id: '/_authenticated/evaluation';
      path: '/evaluation';
      fullPath: '/evaluation';
      preLoaderRoute: typeof AuthenticatedEvaluationRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/profile': {
      id: '/_authenticated/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof AuthenticatedProfileRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/reference': {
      id: '/_authenticated/reference';
      path: '/reference';
      fullPath: '/reference';
      preLoaderRoute: typeof AuthenticatedReferenceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/invite/$token': {
      id: '/invite/$token';
      path: '/invite/$token';
      fullPath: '/invite/$token';
      preLoaderRoute: typeof InviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password/$token': {
      id: '/reset-password/$token';
      path: '/reset-password/$token';
      fullPath: '/reset-password/$token';
      preLoaderRoute: typeof ResetPasswordTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/acts/': {
      id: '/_authenticated/acts/';
      path: '/acts';
      fullPath: '/acts/';
      preLoaderRoute: typeof AuthenticatedActsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/acts/$actId': {
      id: '/_authenticated/acts/$actId';
      path: '/acts/$actId';
      fullPath: '/acts/$actId';
      preLoaderRoute: typeof AuthenticatedActsActIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/ai-providers': {
      id: '/_authenticated/admin/ai-providers';
      path: '/admin/ai-providers';
      fullPath: '/admin/ai-providers';
      preLoaderRoute: typeof AuthenticatedAdminAiProvidersRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/external-calls': {
      id: '/_authenticated/admin/external-calls';
      path: '/admin/external-calls';
      fullPath: '/admin/external-calls';
      preLoaderRoute: typeof AuthenticatedAdminExternalCallsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/roles': {
      id: '/_authenticated/admin/roles';
      path: '/admin/roles';
      fullPath: '/admin/roles';
      preLoaderRoute: typeof AuthenticatedAdminRolesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/';
      path: '/documents';
      fullPath: '/documents/';
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/documents/$documentId': {
      id: '/_authenticated/documents/$documentId';
      path: '/documents/$documentId';
      fullPath: '/documents/$documentId';
      preLoaderRoute: typeof AuthenticatedDocumentsDocumentIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/drafts/': {
      id: '/_authenticated/drafts/';
      path: '/drafts';
      fullPath: '/drafts/';
      preLoaderRoute: typeof AuthenticatedDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/drafts/$draftId': {
      id: '/_authenticated/drafts/$draftId';
      path: '/drafts/$draftId';
      fullPath: '/drafts/$draftId';
      preLoaderRoute: typeof AuthenticatedDraftsDraftIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security';
      path: '/settings/security';
      fullPath: '/settings/security';
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/';
      path: '/templates';
      fullPath: '/templates/';
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/templates/$templateId': {
      id: '/_authenticated/templates/$templateId';
      path: '/templates/$templateId';
      fullPath: '/templates/$templateId';
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/members/': {
      id: '/_authenticated/admin/members/';
      path: '/admin/members';
      fullPath: '/admin/members/';
      preLoaderRoute: typeof AuthenticatedAdminMembersIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/members/$userId': {
      id: '/_authenticated/admin/members/$userId';
      path: '/admin/members/$userId';
      fullPath: '/admin/members/$userId';
      preLoaderRoute: typeof AuthenticatedAdminMembersUserIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/members/invitations': {
      id: '/_authenticated/admin/members/invitations';
      path: '/admin/members/invitations';
      fullPath: '/admin/members/invitations';
      preLoaderRoute: typeof AuthenticatedAdminMembersInvitationsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/members/invite': {
      id: '/_authenticated/admin/members/invite';
      path: '/admin/members/invite';
      fullPath: '/admin/members/invite';
      preLoaderRoute: typeof AuthenticatedAdminMembersInviteRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/teams/': {
      id: '/_authenticated/admin/teams/';
      path: '/admin/teams';
      fullPath: '/admin/teams/';
      preLoaderRoute: typeof AuthenticatedAdminTeamsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/admin/teams/$teamId': {
      id: '/_authenticated/admin/teams/$teamId';
      path: '/admin/teams/$teamId';
      fullPath: '/admin/teams/$teamId';
      preLoaderRoute: typeof AuthenticatedAdminTeamsTeamIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/templates/$templateId_/fill': {
      id: '/_authenticated/templates/$templateId_/fill';
      path: '/templates/$templateId/fill';
      fullPath: '/templates/$templateId/fill';
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdFillRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/templates/$templateId_/assemblies/$assemblyId': {
      id: '/_authenticated/templates/$templateId_/assemblies/$assemblyId';
      path: '/templates/$templateId/assemblies/$assemblyId';
      fullPath: '/templates/$templateId/assemblies/$assemblyId';
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/templates/$templateId_/versions/$versionId/edit': {
      id: '/_authenticated/templates/$templateId_/versions/$versionId/edit';
      path: '/templates/$templateId/versions/$versionId/edit';
      fullPath: '/templates/$templateId/versions/$versionId/edit';
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute;
  AuthenticatedAcknowledgementsRoute: typeof AuthenticatedAcknowledgementsRoute;
  AuthenticatedAssistantRoute: typeof AuthenticatedAssistantRoute;
  AuthenticatedContractsRoute: typeof AuthenticatedContractsRoute;
  AuthenticatedCorrespondenceRoute: typeof AuthenticatedCorrespondenceRoute;
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedEvaluationRoute: typeof AuthenticatedEvaluationRoute;
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute;
  AuthenticatedReferenceRoute: typeof AuthenticatedReferenceRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedActsActIdRoute: typeof AuthenticatedActsActIdRoute;
  AuthenticatedAdminAiProvidersRoute: typeof AuthenticatedAdminAiProvidersRoute;
  AuthenticatedAdminExternalCallsRoute: typeof AuthenticatedAdminExternalCallsRoute;
  AuthenticatedAdminRolesRoute: typeof AuthenticatedAdminRolesRoute;
  AuthenticatedDocumentsDocumentIdRoute: typeof AuthenticatedDocumentsDocumentIdRoute;
  AuthenticatedDraftsDraftIdRoute: typeof AuthenticatedDraftsDraftIdRoute;
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute;
  AuthenticatedTemplatesTemplateIdRoute: typeof AuthenticatedTemplatesTemplateIdRoute;
  AuthenticatedActsIndexRoute: typeof AuthenticatedActsIndexRoute;
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute;
  AuthenticatedDraftsIndexRoute: typeof AuthenticatedDraftsIndexRoute;
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute;
  AuthenticatedAdminMembersUserIdRoute: typeof AuthenticatedAdminMembersUserIdRoute;
  AuthenticatedAdminMembersInvitationsRoute: typeof AuthenticatedAdminMembersInvitationsRoute;
  AuthenticatedAdminMembersInviteRoute: typeof AuthenticatedAdminMembersInviteRoute;
  AuthenticatedAdminTeamsTeamIdRoute: typeof AuthenticatedAdminTeamsTeamIdRoute;
  AuthenticatedTemplatesTemplateIdFillRoute: typeof AuthenticatedTemplatesTemplateIdFillRoute;
  AuthenticatedAdminMembersIndexRoute: typeof AuthenticatedAdminMembersIndexRoute;
  AuthenticatedAdminTeamsIndexRoute: typeof AuthenticatedAdminTeamsIndexRoute;
  AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute: typeof AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute;
  AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute: typeof AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAcknowledgementsRoute: AuthenticatedAcknowledgementsRoute,
  AuthenticatedAssistantRoute: AuthenticatedAssistantRoute,
  AuthenticatedContractsRoute: AuthenticatedContractsRoute,
  AuthenticatedCorrespondenceRoute: AuthenticatedCorrespondenceRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEvaluationRoute: AuthenticatedEvaluationRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedReferenceRoute: AuthenticatedReferenceRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedActsActIdRoute: AuthenticatedActsActIdRoute,
  AuthenticatedAdminAiProvidersRoute: AuthenticatedAdminAiProvidersRoute,
  AuthenticatedAdminExternalCallsRoute: AuthenticatedAdminExternalCallsRoute,
  AuthenticatedAdminRolesRoute: AuthenticatedAdminRolesRoute,
  AuthenticatedDocumentsDocumentIdRoute: AuthenticatedDocumentsDocumentIdRoute,
  AuthenticatedDraftsDraftIdRoute: AuthenticatedDraftsDraftIdRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedTemplatesTemplateIdRoute: AuthenticatedTemplatesTemplateIdRoute,
  AuthenticatedActsIndexRoute: AuthenticatedActsIndexRoute,
  AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  AuthenticatedDraftsIndexRoute: AuthenticatedDraftsIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedAdminMembersUserIdRoute: AuthenticatedAdminMembersUserIdRoute,
  AuthenticatedAdminMembersInvitationsRoute:
    AuthenticatedAdminMembersInvitationsRoute,
  AuthenticatedAdminMembersInviteRoute: AuthenticatedAdminMembersInviteRoute,
  AuthenticatedAdminTeamsTeamIdRoute: AuthenticatedAdminTeamsTeamIdRoute,
  AuthenticatedTemplatesTemplateIdFillRoute:
    AuthenticatedTemplatesTemplateIdFillRoute,
  AuthenticatedAdminMembersIndexRoute: AuthenticatedAdminMembersIndexRoute,
  AuthenticatedAdminTeamsIndexRoute: AuthenticatedAdminTeamsIndexRoute,
  AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute:
    AuthenticatedTemplatesTemplateIdAssembliesAssemblyIdRoute,
  AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute:
    AuthenticatedTemplatesTemplateIdVersionsVersionIdEditRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
